<li [class]="parameter.cfr_code">
  <!-- [attr.for] pairs the label with the control it names, which nothing did before 2026-08-14: no
       parameter field had an accessible name at all, so a form of more than one parameter could not be
       driven - nor audited - by anything reading the accessibility tree, and the label was not
       clickable either. For a LOV the target is not this component's own input but the real focusable
       one ng-select renders, which it exposes through [labelForId] - see lov-select.component.html. -->
  <label [class.required]="isRequired" class="label" [attr.for]="fieldId" [translate]="parameter.cfr_description"></label>

  @if (!hasLov)
  {
    @if (parameter.data_ind_html_control === 'checkbox')
    {
      <!-- [value] must mirror the original's `value="{{ cfr_default_value }}"`: a browser defaults
           a checked checkbox's serialized value to "on" when no value attribute is set, but the
           backend expects the literal string "true"/"false" (matching cfr_default_value). -->
      <input type="checkbox"
             [class.empty]="parameter.cfr_default_value == null"
             [checked]="isChecked"
             [value]="isChecked ? 'true' : 'false'"
             (change)="onCheckboxChange($any($event.target).checked)"
             [id]="fieldId"
             [name]="parameter.cfr_code"
             [title]="parameter.cfr_user_hint_i18n" />
    }
    @else
    {
      <!-- [attr.name], not [name]: ngModel on this element already claims the `name` @Input for
           its own form-control-registration purposes, so a plain [name] binding never reaches
           the actual DOM attribute - which means native form serialization (FormData, a real
           submit) silently drops the field entirely. [attr.name] forces the real HTML attribute. -->
      <input [type]="parameter.data_ind_html_control"
             [class.empty]="parameter.cfr_default_value == null"
             [required]="isRequired"
             [(ngModel)]="parameter.cfr_default_value"
             (ngModelChange)="onTextChange()"
             [placeholder]="placeholder"
             [id]="fieldId"
             [attr.name]="parameter.cfr_code"
             [title]="parameter.cfr_user_hint_i18n" />
    }
  }
  @else
  {
    <app-lov-select [parameter]="parameter" [lovRows]="lovRows" [fieldId]="fieldId"></app-lov-select>
  }

  <div class="userHintWrapper">
    @if (parameter.cfr_user_hint_i18n)
    {
      <span class="userhint" [title]="parameter.cfr_user_hint | translate">?</span>
    }
    <span class="userhintcontent" [translate]="parameter.cfr_user_hint ?? ''"></span>
  </div>
</li>
